export const SET_USER_AUTHENTICATED = 'SET_USER_AUTHENTICATED';
export const SET_USER_NOT_AUTHENTICATED = 'SET_USER_NOT_AUTHENTICATED';